import React, { useEffect } from "react";
import AOS from "aos";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import "./collection.css";

export default function Collections({ data = [] }) {
	// Make sure data is an array before using .sort()
	const filteredData = Array.isArray(data)
		? data.sort(() => 0.5 - Math.random()).slice(0, 3)
		: [];

	useEffect(() => {
		AOS.init({
			duration: 500,
			easing: "ease-in-out",
			once: true,
		});
	}, []);

	return (
		<div className="mb-20 px-4 md:px-10">
			{/* Section Title */}
			<div className="text-center font-lora font-semibold text-3xl md:text-5xl mb-20">
				<h3>Discover Your Signature Style</h3>
			</div>

			{/* Flex Layout */}
			<div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 py-10 md:px-10 px-0 font-lora">
				{/* Card 1 */}
				<div className="w-full md:h-[700px] h-[500px] relative overflow-hidden group">
					<img
						src={`https://demo.riskydress.com/images/2026/AZURE/${filteredData[0]?.images?.[0]}`}
						alt="Prom Collection"
						className="w-full h-full object-cover object-left-top transition-transform duration-500 group-hover:scale-105"
					/>
					<div className="absolute inset-0 flex items-end justify-end pb-8 pr-8">
						<Link to={"/prom/2026"}>
							<span className="flex justify-center items-center text-white text-[20px] font-bold uppercase tracking-wider p-3 bg-[#1f4c94] bg-opacity-75 rounded-lg shadow-xl transition-transform duration-500 ease-in-out">
								Step Into Style
								<Icon
									icon="flowbite:arrow-right-outline"
									width="2rem"
									height="2rem"
									style={{ color: "white" }}
									className="ms-5 lg:block md:block hidden"
								/>
							</span>
						</Link>
					</div>
				</div>

				{/* Card 2 */}
				<div className="w-full md:h-[700px] h-[500px] relative overflow-hidden group">
					<img
						src={
							`https://demo.riskydress.com/images/2026/AZURE/${filteredData[1]?.images?.[0]}` ||
							"https://www.amarra.com/cdn/shop/files/89004Nude_Multi_a_1200x.jpg?v=1748346103"
						}
						alt="Bridal Collection"
						className="w-full h-full object-cover object-left-center transition-transform duration-500 group-hover:scale-105"
					/>
					<div className="absolute inset-0 flex items-end justify-end pb-8 pr-8">
						<Link to="/prom/2026">
							<span className="flex justify-center items-center text-white text-[20px] font-bold uppercase tracking-wider p-3 bg-[#1f4c94] bg-opacity-75 rounded-lg shadow-xl transition-transform duration-500 ease-in-out">
								Shine With Grace
								<Icon
									icon="flowbite:arrow-right-outline"
									width="2rem"
									height="2rem"
									style={{ color: "white" }}
									className="ms-5 lg:block md:block hidden"
								/>
							</span>
						</Link>
					</div>
				</div>

				{/* Card 3 */}
				<div className="w-full md:h-[700px] h-[500px] relative overflow-hidden group">
					<img
						src={
							`https://demo.riskydress.com/images/2026/AZURE/${filteredData[2]?.images?.[0]}` ||
							"https://www.amarra.com/cdn/shop/files/89004Nude_Multi_a_1200x.jpg?v=1748346103"
						}
						alt="Evening Collection"
						className="w-full h-full object-cover object-right-top transition-transform duration-500 group-hover:scale-105"
					/>
					<div className="absolute inset-0 flex items-end justify-end pb-8 pr-8">
						<Link to="/prom/2026">
							<span className="flex justify-center items-center text-white text-[20px] font-bold uppercase tracking-wider p-3 bg-[#1f4c94] bg-opacity-75 rounded-lg shadow-xl transition-transform duration-500 ease-in-out">
								Wear Your Bold
								<Icon
									icon="flowbite:arrow-right-outline"
									width="2rem"
									height="2rem"
									style={{ color: "white" }}
									className="ms-5 lg:block md:block hidden"
								/>
							</span>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
